import { useEffect, useState } from "react";
import AdminNavbar from "../../components/AdminNavbar";
import { useYearContext } from "../../hooks/useYearContext"
import { useAuthContext } from "../../hooks/useAuthContext";
import { Team, Group, GroupCode, Player } from "../../types";

const Teams = () => {

    const { user } = useAuthContext();
    const { current } = useYearContext()
    const [teams, setTeams] = useState<Team[]>()
    const [groups, setGroups] = useState<Group[]>()
    const [newTeamName, setNewTeamName] = useState<string>('')
    const [editedTeamName, setEditedTeamName] = useState<string>('')
    const [selected, setSelected] = useState<Team>()
    const [deleteTeam, setDeleteTeam] = useState<string>('');
    const [players, setPlayers] = useState<Player[]>([])
    const [codes, setCodes] = useState<GroupCode[]>([])
    useEffect(() => {
        const getTeams = async () => {
            if (!user || !current) return;
            const response = await fetch(`${process.env.REACT_APP_PATH}/api/teams?year=${current.year}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
            })
            const json = await response.json()
            if (response.ok) {
                setTeams(json)
                setSelected(json[0])
                getGroups()
                getGroupCodes()
            } else {
                alert(json.error)
            }
        }

        getTeams();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current, user])

    const createTeam = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!user || !current) return;
        if (newTeamName.length <= 3) {
            alert("Názov tímu je príliš krátky")
        } else {
            const response = await fetch(`${process.env.REACT_APP_PATH}/api/teams`, {
                method: 'POST',
                body: JSON.stringify({ name: newTeamName, year: current.year }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
            })
            const json = await response.json()
            if (response.ok) {
                var temp = teams || [];
                temp.push(json[0])
                setTeams([...temp])
                setSelected(json[0])
                setNewTeamName('')


            } else {
                alert(json.error)
            }
        }

    }
    const changeTeamName = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!user || !teams || !selected) return;
        if (editedTeamName.length <= 3) {
            alert("Názov tímu je príliš krátky")
        } else {
            const response = await fetch(`${process.env.REACT_APP_PATH}/api/teams/${selected.ID}`, {
                method: 'PATCH',
                body: JSON.stringify({ name: editedTeamName }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                }
            })
            const json = await response.json()
            if (response.ok) {
                var temp = teams
                const team = temp.find(e => e.ID === selected.ID);
                if (team) {
                    team.name = editedTeamName;
                }

                setTeams([...temp])
                let tempSel = selected;
                tempSel.name = editedTeamName;
                setSelected({ ...tempSel })


            } else {
                alert(json.error)
            }
        }

    }

    const getGroupCodes = async () => {
        if (!current) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/group/codes?year=${current.year}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
        const json = await response.json()
        if (response.ok) {
            setCodes(json)
        } else {
            alert(json.error)
        }
    }

    const getGroups = async () => {
        if (!user || !current) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/group?year=${current.year}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if (response.ok) {
            setGroups(json)
        }
    }

    const [, setNewGroup] = useState<number>()
    const [selectedCodes, setSelectedCodes] = useState<number[]>([])
    useEffect(() => {
        if (selected) {
            setNewGroup(selected.group_code)
            // Initialize selectedCodes with team's current codes
            if (selected.group_codes && Array.isArray(selected.group_codes)) {
                setSelectedCodes(selected.group_codes)
            } else if (selected.group_code) {
                setSelectedCodes([selected.group_code])
            } else {
                setSelectedCodes([])
            }
            setEditedTeamName(selected.name)
            setDeleteTeam('')

            if (!players.find(x => x.team_id === selected.ID)) {
                getPlayers(selected.ID);
            }



        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, players])

    const [deleted, setDeleted] = useState<boolean>(true)
    useEffect(() => {
        if (teams) {
            if (deleted) {
                if (teams[0]) {
                    setSelected(teams[0])
                }

            } else {
                setDeleted(true)
            }

        }

    }, [teams, deleted])


    const saveNewGroup = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!user || !teams || !selected) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/teams/${selected.ID}`, {
            method: 'PATCH',
            body: JSON.stringify({ group_codes: selectedCodes }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        if (response.ok) {
            var temp = teams
            const team = temp.find(e => e.ID === selected.ID);
            if (team) {
                team.group_codes = selectedCodes;
                const codeNames = selectedCodes.map(codeId => codes.find(c => c.ID === codeId)?.name).filter(n => n).join(', ');
                team.group_codes_names = codeNames;
            }
            setTeams([...temp])
        }
    }

    const toggleCodeSelection = (codeId: number) => {
        if (selectedCodes.includes(codeId)) {
            setSelectedCodes(selectedCodes.filter(id => id !== codeId))
        } else {
            setSelectedCodes([...selectedCodes, codeId])
        }
    }

    const deleteThisTeam = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!user || !teams || !selected) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/teams/${selected.ID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if (response.ok) {
            var temp = teams.filter(e => e.ID !== selected.ID)
            setTeams([...temp])
        } else {

            alert(json.error);
        }
    }


    const getPlayers = async (teamID: number) => {
        if (!user || !current) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/player?year=${current.year}&team=${teamID}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if (response.ok) {
            var temp = players
            temp = temp.concat(json)
            setPlayers([...temp])
        } else {
            alert(json.error)
        }
    }


    // Modal state for bulk player addition
    const [showModal, setShowModal] = useState<boolean>(false)
    const [editingPlayers, setEditingPlayers] = useState<Array<{
        id: number;
        playerId?: number; // Existing player ID from database
        number: string;
        first_name: string;
        last_name: string;
        role: 'att' | 'def' | 'gk' | '';
        isNew: boolean;
        toDelete?: boolean;
    }>>([])

    const openAddPlayersModal = () => {
        if (!selected) return;
        
        // Load existing players
        const existingPlayers = players
            .filter(x => x.team_id === selected.ID)
            .map((p, idx) => ({
                id: idx + 1,
                playerId: p.ID,
                number: p.number.toString(),
                first_name: p.first_name,
                last_name: p.last_name,
                role: p.role as 'att' | 'def' | 'gk',
                isNew: false,
                toDelete: false
            }))
        
        // Add one empty row for new player
        const newRow = {
            id: existingPlayers.length + 1,
            number: '',
            first_name: '',
            last_name: '',
            role: '' as 'att' | 'def' | 'gk' | '',
            isNew: true,
            toDelete: false
        }
        
        setEditingPlayers([...existingPlayers, newRow])
        setShowModal(true)
    }

    const addNewRow = () => {
        const newId = editingPlayers.length > 0 ? Math.max(...editingPlayers.map(r => r.id)) + 1 : 1
        setEditingPlayers([...editingPlayers, { id: newId, number: '', first_name: '', last_name: '', role: '', isNew: true, toDelete: false }])
    }

    const removeRow = (id: number) => {
        const row = editingPlayers.find(r => r.id === id)
        if (!row) return
        
        if (row.isNew) {
            // Remove new rows immediately
            setEditingPlayers(editingPlayers.filter(r => r.id !== id))
        } else {
            // Mark existing players for deletion
            setEditingPlayers(editingPlayers.map(r => 
                r.id === id ? { ...r, toDelete: !r.toDelete } : r
            ))
        }
    }

    const updateRow = (id: number, field: string, value: string) => {
        setEditingPlayers(editingPlayers.map(row => 
            row.id === id ? { ...row, [field]: value } : row
        ))
    }

    const saveAllPlayers = async () => {
        if (!user || !current || !selected || !teams) return;

        const errors: string[] = []
        const rowsToProcess = editingPlayers.filter(row => {
            // Skip rows marked for deletion in validation
            if (row.toDelete) return true
            
            // Skip completely empty new rows
            if (row.isNew && !row.number && !row.first_name && !row.last_name && !row.role) {
                return false
            }

            const rowIndex = editingPlayers.indexOf(row) + 1

            if (!row.number) {
                errors.push(`Riadok ${rowIndex}: Chýba číslo`)
                return false
            }

            const number = parseInt(row.number)
            if (isNaN(number)) {
                errors.push(`Riadok ${rowIndex}: Neplatné číslo`)
                return false
            }

            // Check for duplicate numbers (excluding the current player if editing)
            const duplicateCheck = editingPlayers.find(p => 
                p.id !== row.id && 
                !p.toDelete && 
                p.number === row.number
            )
            if (duplicateCheck) {
                errors.push(`Riadok ${rowIndex}: Číslo ${number} sa už nachádza v zozname`)
                return false
            }

            if (row.first_name.length < 2 || row.last_name.length < 2) {
                errors.push(`Riadok ${rowIndex}: Meno alebo priezvisko je príliš krátke`)
                return false
            }

            if (!row.role || (row.role !== 'att' && row.role !== 'def' && row.role !== 'gk')) {
                errors.push(`Riadok ${rowIndex}: Vyberte pozíciu`)
                return false
            }

            return true
        })

        if (errors.length > 0) {
            alert('Chyby:\n\n' + errors.join('\n'))
            return
        }

        let addedCount = 0
        let updatedCount = 0
        let deletedCount = 0
        const saveErrors: string[] = []

        // Process all rows
        for (const row of rowsToProcess) {
            try {
                if (row.toDelete && row.playerId) {
                    // Delete existing player
                    const response = await fetch(`${process.env.REACT_APP_PATH}/api/player/${row.playerId}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user.token}`
                        }
                    })
                    if (response.ok) {
                        const temp = players.filter(x => x.ID !== row.playerId)
                        setPlayers([...temp])
                        deletedCount++
                    } else {
                        const json = await response.json()
                        saveErrors.push(`Hráč #${row.number}: ${json.error}`)
                    }
                } else if (row.isNew) {
                    // Add new player
                    const response = await fetch(`${process.env.REACT_APP_PATH}/api/player`, {
                        method: 'POST',
                        body: JSON.stringify({ 
                            team_id: selected.ID, 
                            role: row.role, 
                            first_name: row.first_name, 
                            last_name: row.last_name, 
                            number: row.number, 
                            year: current.year 
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user.token}`
                        }
                    })
                    const json = await response.json()
                    if (response.ok) {
                        const temp = players
                        temp.push(json[0])
                        setPlayers([...temp])
                        addedCount++
                    } else {
                        saveErrors.push(`Nový hráč #${row.number}: ${json.error}`)
                    }
                } else if (row.playerId) {
                    // Update existing player
                    const response = await fetch(`${process.env.REACT_APP_PATH}/api/player/${row.playerId}`, {
                        method: 'PATCH',
                        body: JSON.stringify({ 
                            role: row.role, 
                            first_name: row.first_name, 
                            last_name: row.last_name, 
                            number: row.number 
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${user.token}`
                        }
                    })
                    if (response.ok) {
                        const temp = players.map(p => 
                            p.ID === row.playerId 
                                ? { ...p, number: parseInt(row.number), first_name: row.first_name, last_name: row.last_name, role: row.role as 'att' | 'def' | 'gk' }
                                : p
                        )
                        setPlayers([...temp])
                        updatedCount++
                    } else {
                        const json = await response.json()
                        saveErrors.push(`Hráč #${row.number}: ${json.error}`)
                    }
                }
            } catch (err) {
                saveErrors.push(`Hráč #${row.number}: Chyba servera`)
            }
        }

        // Update team player count
        const netChange = addedCount - deletedCount
        if (netChange !== 0) {
            let tempTeams = teams
            const team = tempTeams.find(x => x.ID === selected.ID)
            if (team && team.player_count !== undefined) {
                team.player_count += netChange
            }
            setDeleted(false)
            setTeams([...tempTeams])
        }

        const messages = []
        if (addedCount > 0) messages.push(`Pridaných: ${addedCount}`)
        if (updatedCount > 0) messages.push(`Upravených: ${updatedCount}`)
        if (deletedCount > 0) messages.push(`Odstránených: ${deletedCount}`)

        if (saveErrors.length > 0) {
            alert(`${messages.join(', ')}\n\nChyby:\n${saveErrors.join('\n')}`)
        } else if (messages.length > 0) {
            alert(`Úspešne! ${messages.join(', ')}`)
            setShowModal(false)
        } else {
            alert('Žiadne zmeny na uloženie')
        }
    }

    const deletePlayer = async (e: Player) => {
        if (!user || !teams || !selected) return;
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/player/${e.ID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if (response.ok) {
            var temp = players.filter(x => x.ID !== e.ID)
            setPlayers([...temp])

            let tempTeams = teams
            const team = tempTeams.find(x => x.ID === selected.ID);
            if (team && team.player_count !== undefined) {
                team.player_count--;
            }
            setTeams([...tempTeams])

        } else {
            alert(json.error)
        }
    }

    const [editPlayerIndex, setEditPlayerIndex] = useState<number>(-1);

    const [eNumber, setENumber] = useState<string>('')
    const [eName, setEName] = useState<string>('')
    const [eSurname, setESurname] = useState<string>('')
    const [ePostion, setEPosition] = useState<'att' | 'def' | 'gk' | ''>('')


    const setEditThisPlayer = (x: number) => {
        if (!selected) return;
        setEditPlayerIndex(x)
        if (x !== -1) {
            const playersList = players.filter(a => a.team_id === selected.ID);
            setENumber(playersList[x].number.toString())
            setEName(playersList[x].first_name)
            setESurname(playersList[x].last_name)
            const role = playersList[x].role
            setEPosition(role as '' | 'gk' | 'att' | 'def')
        }

    }

    const savePlayerChange = async (x: number) => {
        if (!user || !selected) return;

        const playersList = players.filter(a => a.team_id === selected.ID);
        let fff = playersList[x].team_id
        let ggg = playersList[x].ID
        if (!eNumber) {
            alert("Zadaj číslo!")
            return
        } else if (players.filter(p => ((p.team_id === fff) && (p.ID !== ggg))).find(y => y.number === parseInt(eNumber))) {
            alert("Toto číslo sa už v tíme nachádza!")
            return
        }


        if (eName.length < 2 || eSurname.length < 2) {
            alert("Zadaj meno aj priezvisko!")
            return
        }

        if (ePostion !== 'att' && ePostion !== 'def' && ePostion !== 'gk') {
            alert("Zadaj pozíciu!")
            return
        }
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/player/${playersList[x].ID}`, {
            method: 'PATCH',
            body: JSON.stringify({ role: ePostion, first_name: eName, last_name: eSurname, number: eNumber }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })
        const json = await response.json()
        if (response.ok) {
            let temp = players.filter(a => a.team_id === selected.ID)
            temp[x].number = parseInt(eNumber)
            temp[x].first_name = eName
            temp[x].last_name = eSurname
            temp[x].role = ePostion as 'att' | 'def' | 'gk'
            setPlayers([...temp])
            setEditThisPlayer(-1)

        } else {
            alert(json.error)
        }
    }



    return (
        <div className="flex">
            <AdminNavbar />
            <div className="flex-1 p-8">
                <div>
                    <h1 className="text-3xl mb-5">Tímy {current?.year}</h1>
                    {(teams) && <div className="w-full table">
                        <div className="table-row">
                            <div className="table-cell border-b pb-2 text-lg pl-2">Meno</div>
                            <div className="table-cell text-center w-40 border-b pb-2 text-lg">Kódy skupín</div>
                            <div className="table-cell text-center w-20 border-b pb-2 text-lg">Hráči</div>
                            <div className="table-cell text-center w-20 border-b pb-2 text-lg">Body</div>

                        </div>
                        {teams.map(e => (
                            <div key={e.ID} className={`table-row hover:bg-gray-200 cursor-pointer ${selected?.ID === e.ID ? "bg-gray-200" : ""}`} onClick={x => { setSelected(e); setEditThisPlayer(-1) }}>
                                <div className="table-cell border-b pb-2 text-lg pl-2">{e.name}</div>
                                <div className="table-cell text-center w-40 border-b pb-2 text-lg">{e.group_codes_names || e.group_code_name || '-'}</div>
                                <div className="table-cell text-center w-20 border-b pb-2 text-lg">{e.player_count}</div>
                                <div className="table-cell text-center w-20 border-b pb-2 text-lg">{e.points}</div>

                            </div>
                        ))}

                    </div>}
                    <form className="flex items-center mt-10 form" onSubmit={createTeam}>
                        <input type="text" placeholder="Názov Tímu" className="p-1 border border-borders mr-1 text-xl" value={newTeamName} onChange={e => setNewTeamName(e.target.value)} />
                        <button className="btn  whitespace-pre text-xl">Pridať tím</button>
                    </form>

                </div>
                {selected &&
                    <div>
                        <div className="mt-10">
                            <h1 className="text-3xl mb-5">{selected.name}</h1>
                        </div>
                        <div className="flex border-b border-t border-borders py-3 mb-3 items-center child:mx-1 justify-between">
                            <form className="flex flex-col text-xl min-w-[20rem]" onSubmit={saveNewGroup} >
                                <p className="text-xl mb-2">Kódy skupín (vyberte viacero):</p>
                                {codes && <div className="flex flex-wrap max-w-[400px] mb-2">
                                    {codes.filter(c => c.name !== '-').map(e => (
                                        <label key={e.ID} className="flex items-center mr-3 mb-2 cursor-pointer">
                                            <input 
                                                type="checkbox" 
                                                checked={selectedCodes.includes(e.ID)}
                                                onChange={() => toggleCodeSelection(e.ID)}
                                                className="mr-2"
                                            />
                                            <span className="text-lg">{e.name}</span>
                                        </label>
                                    ))}
                                </div>}
                                {groups && <button 
                                    disabled={JSON.stringify(selectedCodes.sort()) === JSON.stringify((selected.group_codes || [selected.group_code || 0]).sort())} 
                                    className="btn w-32"
                                >
                                    Uložiť
                                </button>}
                            </form>
                            <form className="flex items-center" onSubmit={changeTeamName}>
                                <p className="text-xl mr-3">Zmeniť meno: </p>
                                <input type="text" placeholder="Nové meno tímu" className="p-1 border border-borders mr-1 text-xl max-w-[140px]" value={editedTeamName} onChange={e => setEditedTeamName(e.target.value)} />
                                <button disabled={selected.name === editedTeamName} className="btn  whitespace-pre text-xl">Zmeniť</button>
                            </form>

                            <form className="flex items-center" onSubmit={deleteThisTeam}>
                                <p className="text-xl mr-3">Odstrániť tento tím: </p>
                                <input type="text" placeholder="Potvrď meno" className="p-1 border border-borders mr-1 text-xl max-w-[140px]" value={deleteTeam} onChange={e => setDeleteTeam(e.target.value)} />
                                <button disabled={selected.name !== deleteTeam} className="btn  whitespace-pre text-xl">Odstrániť</button>
                            </form>
                        </div>
                        <div className="mt-10">
                            <h1 className="text-2xl mb-5">Hráči</h1>
                            {(teams) && <div className="w-full table ">
                                <div className="table-row">
                                    <div className="table-cell border-b pb-2 text-lg pl-2 w-2"></div>
                                    <div className="table-cell border-b pb-2 text-lg pl-2 w-5">Číslo</div>
                                    <div className="table-cell border-b pb-2 text-lg pl-2">Meno</div>
                                    <div className="table-cell text-center w-20 border-b pb-2 text-lg">Pozícia</div>
                                    <div className="table-cell text-center w-20 border-b pb-2 text-lg">Upráva</div>
                                    <div className="table-cell text-center w-20 border-b pb-2 text-lg">Odstránenie</div>

                                </div>
                                {players.filter(x => x.team_id === selected.ID).map((e, i) => (
                                    <div key={e.ID} className={`table-row-group hover:bg-gray-200 cursor-pointer ${selected.ID === e.ID ? "bg-gray-200" : ""}`} >
                                        {i !== editPlayerIndex && <div className="table-row">
                                            <div className="table-cell border-b py-1 text-lg pl-2">{i + 1}.</div>
                                            <div className="table-cell border-b py-1 text-lg pl-2">{e.number}</div>
                                            <div className="table-cell border-b py-1 text-lg pl-2">{e.first_name} {e.last_name}</div>
                                            <div className="table-cell text-center w-20 border-b  text-lg">
                                                {e.role === 'att' && <span>Útočník</span>}
                                                {e.role === 'def' && <span>Obranca</span>}
                                                {e.role === 'gk' && <span>Brankár</span>}
                                            </div>
                                            <div className="table-cell text-center w-20 border-b  text-lg mr-3"><div className="text-accent underline font-bold  " onClick={x => setEditThisPlayer(i)}>Upraviť</div></div>
                                            <div className="table-cell text-center w-20 border-b  text-lg"><div className="text-red-500 underline font-bold" onClick={x => deletePlayer(e)}>Odstrániť</div></div>
                                        </div>}
                                        {i === editPlayerIndex && <div className="table-row">
                                            <div className="table-cell border-b py-1 text-lg pl-2">{i + 1}</div>
                                            <div className="table-cell border-b py-1 text-lg pl-2"><input type="number" placeholder="číslo" className="p-1" value={eNumber} onChange={e => setENumber(e.target.value)} /></div>
                                            <div className="table-cell border-b py-1 text-lg pl-2">
                                                <input type="text" placeholder="Meno" className="mr-2 p-1" value={eName} onChange={e => setEName(e.target.value)} />
                                                <input type="text" className="mr-2 p-1" placeholder="Priezvisko" value={eSurname} onChange={e => setESurname(e.target.value)} />
                                            </div>
                                            <div className="table-cell text-center w-20 border-b  text-lg">
                                                <select className="p-2" value={ePostion} onChange={e => setEPosition(e.target.value as 'att' | 'def' | 'gk' | '')}>
                                                    <option value={''} className="p-1"></option>
                                                    <option value="att" className="p-1">Útočník</option>
                                                    <option value="def" className="p-1">Obranca</option>
                                                    <option value="gk" className="p-1">Brankár</option>
                                                </select>
                                            </div>
                                            <div className="table-cell text-center w-20 border-b  text-lg mr-3"><div className="text-accent underline font-bold  " onClick={x => setEditThisPlayer(-1)}>Zrušiť</div></div>
                                            <div className="table-cell text-center w-20 border-b  text-lg"><div className="btn" onClick={q => savePlayerChange(i)}>Uložiť</div></div>
                                        </div>}


                                    </div>
                                ))}

                            </div>}
                            <div className="mt-5">
                                <button className="btn text-xl px-6 py-3" onClick={openAddPlayersModal}>
                                    + Pridať hráčov
                                </button>
                            </div>
                        </div>
                    </div>
                }

            </div>

            {/* Modal for adding players */}
            {showModal && selected && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={() => setShowModal(false)}>
                        <div className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-2xl font-bold">Pridať hráčov do tímu {selected?.name}</h2>
                                <button onClick={() => setShowModal(false)} className="text-2xl font-bold hover:text-red-500">&times;</button>
                            </div>
                            
                            <div className="overflow-x-auto">
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr className="bg-gray-100">
                                            <th className="border p-2 text-left w-10">#</th>
                                            <th className="border p-2 text-left w-24">Číslo</th>
                                            <th className="border p-2 text-left">Meno</th>
                                            <th className="border p-2 text-left">Priezvisko</th>
                                            <th className="border p-2 text-left w-32">Pozícia</th>
                                            <th className="border p-2 text-center w-20">Akcia</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {editingPlayers.map((row, index) => (
                                            <tr key={row.id} className={`hover:bg-gray-50 ${row.toDelete ? 'bg-red-100 line-through opacity-50' : ''}`}>
                                                <td className="border p-2">{index + 1}</td>
                                                <td className="border p-2">
                                                    <input
                                                        type="number"
                                                        className="w-full p-1 border rounded"
                                                        value={row.number}
                                                        onChange={(e) => updateRow(row.id, 'number', e.target.value)}
                                                        placeholder="#"
                                                        disabled={row.toDelete}
                                                    />
                                                </td>
                                                <td className="border p-2">
                                                    <input
                                                        type="text"
                                                        className="w-full p-1 border rounded"
                                                        value={row.first_name}
                                                        onChange={(e) => updateRow(row.id, 'first_name', e.target.value)}
                                                        placeholder="Meno"
                                                        disabled={row.toDelete}
                                                    />
                                                </td>
                                                <td className="border p-2">
                                                    <input
                                                        type="text"
                                                        className="w-full p-1 border rounded"
                                                        value={row.last_name}
                                                        onChange={(e) => updateRow(row.id, 'last_name', e.target.value)}
                                                        placeholder="Priezvisko"
                                                        disabled={row.toDelete}
                                                    />
                                                </td>
                                                <td className="border p-2">
                                                    <select
                                                        className="w-full p-1 border rounded"
                                                        value={row.role}
                                                        onChange={(e) => updateRow(row.id, 'role', e.target.value)}
                                                        disabled={row.toDelete}
                                                    >
                                                        <option value="">Vyber...</option>
                                                        <option value="att">Útočník</option>
                                                        <option value="def">Obranca</option>
                                                        <option value="gk">Brankár</option>
                                                    </select>
                                                </td>
                                                <td className="border p-2 text-center">
                                                    <button
                                                        onClick={() => removeRow(row.id)}
                                                        className={`font-bold ${row.toDelete ? 'text-green-500 hover:text-green-700' : 'text-red-500 hover:text-red-700'}`}
                                                        title={row.toDelete ? 'Zrušiť odstránenie' : (row.isNew ? 'Odstrániť riadok' : 'Označiť na odstránenie')}
                                                    >
                                                        {row.toDelete ? '↶' : '✕'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="flex justify-between items-center mt-4">
                                <button
                                    onClick={addNewRow}
                                    className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
                                >
                                    + Pridať riadok
                                </button>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => setShowModal(false)}
                                        className="px-6 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                                    >
                                        Zrušiť
                                    </button>
                                    <button
                                        onClick={saveAllPlayers}
                                        className="btn px-6 py-2"
                                    >
                                        Uložiť všetkých
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </div >
    );
}

export default Teams;
